import React, { useState } from "react";
import { Button, Modal, Typography, Tooltip, message } from "antd";
import { CopyOutlined, CheckOutlined } from "@ant-design/icons";
import DescriptionIcon from "../../assets/information.png"; 

const DescriptionModal = ({ data }) => {
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [copied, setCopied] = useState(false);

  const showModal = () => setIsModalVisible(true);
  const handleClose = () => setIsModalVisible(false);

  const copyToClipboard = async () => {
    try {
      await navigator.clipboard.writeText(data?.description || "");
      setCopied(true);
      message.success("Copied to clipboard!");
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      message.error("Failed to copy text");
      console.error("Failed to copy:", err);
    }
  };

  return (
    <>
      <Button
        onClick={showModal}
        style={{ 
          marginLeft: '5px',
          height: '34px',
          width: '34px',
          padding: '0',
          backgroundColor: '#A9A9A9',
          border: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          justifyContent: 'center',
          verticalAlign: 'top'
        }}
        className="!hover:bg-[#A9A9A9] !focus:bg-[#A9A9A9]"
      >
        <Tooltip title="Click to view full description">
          <img
            src={DescriptionIcon}
            alt="Description"
            style={{
              width: '34px',
              height: '34px'
            }}
          />
        </Tooltip>
      </Button>

      <Modal
        title="Description"
        visible={isModalVisible}       // Updated `open` to `visible`
        onCancel={handleClose}         // Set onCancel to call handleClose
        maskClosable={true}            // Allows closing modal by clicking outside
        footer={[
          <Button
            key="copy"
            type={copied ? "default" : "primary"}
            icon={copied ? <CheckOutlined /> : <CopyOutlined />}
            onClick={copyToClipboard}
            style={{ width: '150px' }}
          >
            {copied ? "Copied!" : "Copy Text"}
          </Button>
        ]}
        width={500}
      >
        <div
          style={{
            background: '#f5f5f5',
            padding: '16px',
            borderRadius: '8px',
            marginTop: '16px',
            maxHeight: '400px',
            overflowY: 'auto'
          }}
        >
          <Typography.Text
            style={{
              whiteSpace: 'pre-wrap',
              wordBreak: 'break-word',
              color: '#262626'
            }}
          >
            {data?.description || "No description available"}
          </Typography.Text>
        </div>
      </Modal>
    </>
  );
};

export default DescriptionModal;
